import { createMiddleware } from 'redux-beacon';
import { gtm } from './tag-manager';
import { HeaderEventsMap } from 'store/googleTagManager/eventMaps/headerEventsMaps';
import { EventsMap } from 'store/googleTagManager/eventMaps/eventsMap';
import { CheckoutEventsMap } from 'store/googleTagManager/eventMaps/checkoutEventsMap';

export const googleTagManagerMiddleware = createMiddleware(EventsMap, gtm);
export const googleTagManagerHeaderMiddleware = createMiddleware(HeaderEventsMap, gtm);
export const googleTagManagerCheckoutMiddleware = createMiddleware(CheckoutEventsMap, gtm);
